import request from '@/utils/request'

export function getUuid() {
    return request({
        url: '/web/uuid/getUuid',
        method: 'get'
    })
}

// 获取验证码
// export function getPhoneCode(phone) {
//     return request({
//         url: `/api/login/send/${phone}`,
//         method: "get",
//     });
// }
export function getPhoneCode(data) {
    return request({
        url: `/webApi/sendSmsMessage`,
        method: "post",
        data: data
    });
}

//用户登录操作
export function loginIn(data) {
    return request({
        url: '/web/user/login',
        method: 'put',
        data: data
    })
}


//用户登出操作
export function logOut(data) {
    return request({
        url: '/web/user/logout',
        method: 'put',
        data: data
    })
}


//更换绑定的手机号
// PUT http://localhost:1012/web/user/switchingBinding
export function switchingBinding(data) {
    return request({
        url: '/web/user/switchingBinding',
        method: 'put',
        data: data
    })
}


// GET http://localhost:1012/web/user/existenceOrNot/{{ldGx007a}}
//获取验证码之前先校验当前手机号是否已注册
export function existenceOrNot(data) {
    return request({
        url: '/web/user/existenceOrNot/'+data,
        method: 'get',
    })
}

export function wechatLoginLog(id) {
    return request({
        url: '/web/wechatLoginLog/'+id,
        method: 'get',
    })
}
//电子社保卡连接获取
export function getsbklogin(data) {
    return request({
        url: '/web/dzsbk/getFiveQrCode',
        method: 'post',
        data
    })
}

//电子社保卡登录
export function sbktoken(id) {
    return request({
        url: '/web/dzsbk/queryFiveQrCode/'+id,
        method: 'get',
    })
}

//登录
export function sbklogins(data) {
    return request({
        url: '/web/dzsbk/login',
        method: 'PUT',
        data
    })
}
